import { useQueryWithSimpleErrorHandling } from "hooks/apolloWrappers";
import { getOperationName } from "@apollo/client/utilities";
import { initialState } from "../constants";

export const useVersion = (query, options = {}) => {
  const { data, loading } = useQueryWithSimpleErrorHandling(query, options);
  const operationName = getOperationName(query);

  const result = data?.[operationName] ?? { ...initialState };
  return {
    version: result.version,
    date: result?.date,
    loading
  };
};
